// external dependencies
import { object } from 'prop-types'
import React, { useLayoutEffect } from 'react'
import { graphql } from 'gatsby'
import { ThemeProvider } from 'emotion-theming'

import { init as esInit } from '@bizdotcom/event-stream-pixel'
import RfqProvider from '@duplo/components/lib/RfqProvider'
import TrackingWrapper from '@duplo/components/lib/TrackingWrapper'

// graphql fragment
import { qsData } from 'constants/graphqlQueries' // eslint-disable-line no-unused-vars

import CallConnectProvider from '@duplo/components/lib/CallConnect/CallConnectAvailability'
import Layout from 'components/layout'

// relative components
import View from './View'

// theme
import theme from '@duplo/themes/lib/bluecrush'

BlueCrushTemplate.propTypes = {
	data: object,
	pageContext: object,
}

function BlueCrushTemplate(props) {
	/* using useLayoutEffect hook here because i need this to happen BEFORE anything renders so that by the time
	any tracking calls are made the pixel is definitley intialized!  for more info on the difference between
	and useLayoutEffect see here: https://reactjs.org/docs/hooks-reference.html#uselayouteffect */
	useLayoutEffect(() => {
		// Initialize the Event Stream pixel
		esInit({ stage: process.env.GATSBY_ES_STAGE })
	}, [])

	return (
		<Layout>
			<ThemeProvider theme={theme}>
				<RfqProvider
					categoryData={props.data.bzCategory}
					orchId={props.pageContext.orchId}
					pageContext={props.pageContext}
				>
					<CallConnectProvider>
						<TrackingWrapper>
							<View />
						</TrackingWrapper>
					</CallConnectProvider>
				</RfqProvider>
			</ThemeProvider>
		</Layout>
	)
}

export default BlueCrushTemplate

export const pageQuery = graphql`
	query bluecrushCategoryQuery($id: String!) {
		bzCategory(id: { eq: $id }) {
			altImage1
			categoryId
			categoryName
			contentPath
			productIcon
			productImage
			...qsData
		}
	}
`
